import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { GlobalVariable } from './../shared/global';

import 'rxjs/add/operator/toPromise';

@Injectable()
export class PlanDetailsService {

	private baseApiUrlTest = GlobalVariable.BASE_API_URL;

	private reqHeaders = new Headers({ 'Content-Type': 'application/json' });
	private get_plan_url = this.baseApiUrlTest + 'api/enrollment/get/plan/';
	private get_document = this.baseApiUrlTest + 'api/enrollment/download/document/';
	private get_document_by_tdu = this.baseApiUrlTest + 'api/enrollment/download/document/';
	private check_esiid = this.baseApiUrlTest + 'api/enrollment/check/esiid/';
	private check_esiid_hold_details = this.baseApiUrlTest + 'api/enrollment/check/esiid/hold/';
	private promotion_hold = this.baseApiUrlTest + 'api/enrollment/check/promotionhold/';
	private validate_switc_hold = this.baseApiUrlTest + 'api/enrollment/validateSwitchHoldIndicator/esiid/'

	constructor(private http: Http) { }

	getPlan(address_with_tdu: Object) {
		return this.http.post(this.get_plan_url, address_with_tdu)
			.toPromise()
			.then(response => response.json())
			.catch(this.handleError);
	}

	getPlanDetails(request: Object) {
		return this.http.post(this.get_plan_url, request)
			.toPromise()
			.then(response => response.json())
			.catch(this.handleError);
	}

	getDocument(document_name: string, language: string) {
		return this.http.get(this.get_document + language + '/' + document_name + '/')
			.toPromise()
			.then(response => response.json())
			.catch(this.handleError);
	}

	getDocumentByTDU(document_name: string, language: string, tduCode: string) {
		return this.http.get(this.get_document_by_tdu + language + '/' + document_name + '/' + tduCode)
			.toPromise()
			.then(response => response.json())
			.catch(this.handleError);
	}

	getDocumentUrls() {
		return this.http.get('assets/properties/app.json')
			.toPromise()
			.then(res => res.json())
			.catch(this.handleError);
	}

	getEsiIdHoldDetails(esi_id: string) {

		return this.http.get(this.check_esiid_hold_details + esi_id)
			.toPromise()
			.then(res => res.json())
			.catch(this.handleError);
	}
	validateSwitchHoldIndicator(esi_id: string) {

		return this.http.get(this.validate_switc_hold + esi_id)
			.toPromise()
			.then(res => res.json())
			.catch(this.handleError);
	}

	private handleError(error: any): Promise<any> {
		console.error('An error occurred', error);
		return Promise.reject(error.message || error);
	}
}



// WEBPACK FOOTER //
// ./src/app/plan-details/plan-details.service.ts